import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import withMobileDialog from "@material-ui/core/withMobileDialog";

import { EmptyRecord } from "../../utils/PageUtility";
import RecordPagination from "../../utils/RecordsPagination";
import Edit from "@material-ui/icons/Edit";
import Approve from "@material-ui/icons/DoneOutline";
import Decline from "@material-ui/icons/Close";
import Initiate from "@material-ui/icons/Add";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
//import Button from "components/CustomButtons/Button.jsx";

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
    icon: {
      margin: "8px 0px 8px 8px",
      position: "relative",
      top: "7px",
      paddingLeft: "8px",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  tableStyle: {
    padding: "10px",
  },
};

const CustomTableCell = withStyles((theme) => ({
  head: {
    color: " #04137b",
    fontSize: "14px",
    fontWeight: "lighter",
    padding: "20px",
  },
  body: {
    fontSize: 14,
    padding: "20px",
  },
}))(TableCell);

const AllInvoicesTableStructure = ({
  classes,
  records,
  user,
  handleEdit,
  openModal,
  pageIndex,
  handleApproveRejectModal,
}) => (
  <Table className={classes.table} aria-labelledby="tableTitle">
    <TableHead className={classes.negativeColor} color="primary">
      <TableRow>
        <CustomTableCell>S/N</CustomTableCell>
        <CustomTableCell>Invoice</CustomTableCell>
        <CustomTableCell>Invoice Date</CustomTableCell>
        <CustomTableCell>Amount </CustomTableCell>
        <CustomTableCell>Amount Paid </CustomTableCell>
        <CustomTableCell>Airport</CustomTableCell>
        <CustomTableCell>Airline</CustomTableCell>
        <CustomTableCell>Payment Date</CustomTableCell>
        <CustomTableCell>Status</CustomTableCell>
        <CustomTableCell>Action</CustomTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {records &&
        records.map((item, key) => {
          return (
            <TableRow hover key={key}>
              <CustomTableCell component="th">
                {pageIndex + key}
              </CustomTableCell>
              <CustomTableCell>{item.InvoiceNumber}</CustomTableCell>
              <CustomTableCell>
                {item.InvoiceDate
                  ? appHelpers.formatDate(item.InvoiceDate, "MMM DD, YYYY")
                  : ""}
              </CustomTableCell>
              <CustomTableCell>
                {item.CurrencyCode} {appHelpers.numberWithCommas(item.Amount)}
              </CustomTableCell>
              <CustomTableCell>
                {item.CurrencyCode}{" "}
                {appHelpers.numberWithCommas(item.AmountPaid)}
              </CustomTableCell>
              <CustomTableCell>{item.Location}</CustomTableCell>
              <CustomTableCell>{item.AirlineName}</CustomTableCell>
              <CustomTableCell>
                {item.PaymentDate
                  ? appHelpers.formatDate(item.PaymentDate, "MMM DD, YYYY")
                  : ""}
              </CustomTableCell>
              <CustomTableCell>
                {item.Status === 0 && (
                  <span style={{ color: "#828282" }}>Pending</span>
                )}
                {item.Status === 1 && (
                  <span style={{ color: "#ff9800" }}>Initiated</span>
                )}
                {item.Status === 2 && (
                  <span style={{ color: "#66bb6a" }}>Approved</span>
                )}
                {item.Status === 3 && (
                  <span style={{ color: "#dd2735" }}>Rejected</span>
                )}
              </CustomTableCell>
              <CustomTableCell>
                {item.CreatedBy === user.userId ? (
                  <span
                    style={{ cursor: "pointer", color: "#dd2735" }}
                    onClick={() => handleEdit(item)}
                  >
                    <span
                      style={{
                        margin: "8px 0px 8px 8px",
                        position: "relative",
                        top: "7px",
                        paddingLeft: "8px",
                      }}
                    >
                      <Edit />
                    </span>{" "}
                    Edit
                  </span>
                ) : (
                  ""
                )}
                {item.VerifiedBy !== user.userId && item.Status === 1 ? (
                  <span>
                    <span
                      onClick={() => handleApproveRejectModal(2, item)}
                      style={{ cursor: "pointer", color: "#66bb6a" }}
                    >
                      <span
                        style={{
                          margin: "8px 0px 8px 8px",
                          position: "relative",
                          top: "7px",
                          paddingLeft: "8px",
                        }}
                      >
                        <Approve />{" "}
                      </span>
                    </span>
                    <span
                      onClick={() => handleApproveRejectModal(3, item)}
                      style={{ cursor: "pointer", color: "#dd2735" }}
                      autoFocus
                    >
                      <span
                        style={{
                          margin: "8px 0px 8px 8px",
                          position: "relative",
                          top: "7px",
                          paddingLeft: "8px",
                        }}
                      >
                        <Decline />{" "}
                      </span>
                    </span>
                  </span>
                ) : (
                  ""
                )}
                {item.VerifiedBy !== user.userId &&
                  item.Status === 0 && (
                    <span
                      onClick={() => openModal(1, item)}
                      style={{ cursor: "pointer", color: "#ff9800" }}
                    >
                      <span
                        style={{
                          margin: "8px 0px 8px 8px",
                          position: "relative",
                          top: "7px",
                          paddingLeft: "8px",
                        }}
                      >
                        <Initiate />{" "}
                      </span>
                      Initiate
                    </span>
                  )}
              </CustomTableCell>
            </TableRow>
          );
        })}
    </TableBody>
  </Table>
);

class AllInvoicesTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false,
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({ flight });
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      classes,
      totalCounts,
      handleApprove,
      fetchRecords,
      currentPage,
      pageSize,
      user,
      records,
      openModal,
      handleApproveRejectModal,
    } = this.props;

    // const index = currentPage === 1 ? ((pageSize * (currentPage - 1 )) + 1 ):( (pageSize * (currentPage - 1)) + 1);
    const index = pageSize * (currentPage - 1) + 1;
    if (totalCounts === 0)
      return <EmptyRecord message={"No invoice record!"} />;
    return (
      <div>
        <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
          <RecordPagination
            fetchMore={fetchRecords}
            totalCount={totalCounts}
            pageSize={pageSize}
            currentPage={currentPage}
            target={
              <AllInvoicesTableStructure
                handleApprove={handleApprove}
                records={records}
                classes={classes}
                user={user}
                openModal={openModal}
                pageIndex={index}
                handleApproveRejectModal={handleApproveRejectModal}
              />
            }
          />
        </div>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(AllInvoicesTable));



// WEBPACK FOOTER //
// ./src/Regional-Views/InvoiceApproval/allInvoicesTable.js